module.exports = __webpack_public_path__ + "static/media/dagger-epic.508a91f2.png";